import React, {useEffect, useState} from 'react'
//Components
import {View} from 'react-native';
import {Label, RadioGroup} from "components/src/components";
//Utils
import {CommonStyle, Constants} from "components/src/utils";
import {connect} from "react-redux";

const RADIO_OPTIONS = [
    { name: 'Høyest mulig pris', value: 1 },
    { name: 'At boligen blir solgt raskt', value: 2 },
    { name: 'Ryddig prosess', value: 3 },
    { name: 'Trygt oppgjør', value: 4 },
];


function FirstQuestion(props) {
    const {onChangeAnswer,  interViewForm} = props;

    const [answers, setAnswerFirst] = useState();
    const [answersSec, setAnswer] = useState();

    useEffect(() => {
        props.onAnswer(answers)
    }, [answers]);


    return (
        <View>
            <Label xxlarge
                   font_medium
                   mt={20}>
                {"Hva er det viktigste for deg nå når du skal selge din bolig?"}
            </Label>

            <RadioGroup options={RADIO_OPTIONS}
                        style={{marginVertical: 10}}
                        textStyle={CommonStyle.flex}
                        labelProps={{
                            large: true
                        }}
                        onSelectOption={setAnswerFirst}/>

        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        interViewForm: state.seller_interview
    }
};
const mapDispatchToProps = (dispatch) => {
    return {}

};
export default connect(mapStateToProps, mapDispatchToProps)(FirstQuestion)
